/**
 *
 *  ScrollToTopOnMount
 *  Component
 *
 *  Created by Vladimir Shislyannikov on 17/08/2021.
 *  Copyright (c) 2021 iWoo Ltd. All rights reserved.
 *
 */

import { useEffect } from 'react';

export default function ScrollToTopOnMount() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return null;
}
